<div style="background-color:{{ data?.background }}">
    <ng-container *ngFor="let item of data?.feed; let i = index">
        <div
            *ngIf="item.layoutType === '1-col-banner'"
            class="one-col-banner one-col-banner-mobile"
            ngClass.gt-xs="one-col-banner-desktop"
        >
            <picture
                *ngIf="item?.layoutContent?.banner?.video === null"
                class="one-col-banner-image"
                [ngClass]="{ 'image-banner-shimmer': showShimmer }"
            >
                <img
                    class="image-holder"
                    src="{{ item?.layoutContent?.banner?.image }}"
                    (click)="processLink(item?.layoutContent?.banner?.link)"
                    appImageCDN
                />
            </picture>

            <video
                *ngIf="item?.layoutContent?.banner?.video"
                poster="{{
                    item?.layoutContent?.banner?.image + posterImageCDN
                }}"
                style="
                    clip-path: inset(0px);
                    border: none;
                    position: absolute;
                    top: 0;
                    height: 100%;
                    width: 100%;
                    object-fit: cover;
                "
                loop
                muted
                autoplay
                oncanplay="this.play()"
                onloadedmetadata="this.muted = true"
                playsinline
                webkit-playsinline
            >
                <source
                    src="{{ item?.layoutContent?.banner?.video + webm }}"
                    type="video/webm"
                />
                <source
                    [src]="convertWebToMp4(item?.layoutContent?.banner?.video)"
                    type="video/mp4"
                />
            </video>
            <div
                *ngIf="!!item?.layoutContent?.title?.text"
                class="one-col-banner-content"
                fxLayout="column"
                fxLayout.gt-xs="row"
            >
                <div
                    [fxFlex]="getFlex(item.layoutContent)"
                    [fxFlexOrder]="getFlexOrder(item.layoutContent)"
                    fxLayout="column"
                    fxLayoutAlign="center center"
                >
                    <h1
                        class="banner-heading"
                        [ngClass.lt-md]="{ 'mob-banner-heading': true }"
                        style="color:{{ item?.layoutContent?.title?.color }}"
                    >
                        {{ item?.layoutContent?.title?.text }}
                    </h1>
                    <button
                        *ngIf="item?.layoutContent?.button"
                        mat-flat-button
                        class="mob-button"
                        ngClass.gt-xs="desk-button"
                        style="background: {{
                            item?.layoutContent?.button?.background
                        }};color:{{
                            item?.layoutContent?.button?.title?.color
                        }}"
                    >
                        {{ item?.layoutContent?.button?.title?.text }}
                    </button>
                </div>
                <div #spacer fxFlex="0 1 60%" fxFlexOrder="0"></div>
            </div>
        </div>
        <div
            *ngIf="item.layoutType === '1-col-medium-banner'"
            class="one-col-banner one-col-banner-mobile"
            ngClass.gt-xs="one-col-banner-medium-desktop"
        >
            <picture
                *ngIf="item?.layoutContent?.banner?.video === null"
                class="one-col-banner-image"
                [ngClass]="{ 'image-banner-shimmer': showShimmer }"
            >
                <img
                    class="image-holder"
                    src="{{ item?.layoutContent?.banner?.image }}"
                    (click)="processLink(item?.layoutContent?.banner?.link)"
                    appImageCDN
                />
            </picture>

            <video
                *ngIf="item?.layoutContent?.banner?.video"
                poster="{{
                    item?.layoutContent?.banner?.image + posterImageCDN
                }}"
                style="
                    border: none;
                    position: absolute;
                    top: 0;
                    height: 100%;
                    width: 100%;
                    object-fit: cover;
                "
                loop
                muted
                autoplay
                oncanplay="this.play()"
                onloadedmetadata="this.muted = true"
                playsinline
                webkit-playsinline
            >
                <source
                    src="{{ item?.layoutContent?.banner?.video + webm }}"
                    type="video/webm"
                />
                <source
                    [src]="convertWebToMp4(item?.layoutContent?.banner?.video)"
                    type="video/mp4"
                />
            </video>
            <div
                *ngIf="!!item?.layoutContent?.title?.text"
                class="one-col-banner-content"
                fxLayout="column"
                fxLayout.gt-xs="row"
            >
                <div
                    [fxFlex]="getFlex(item.layoutContent)"
                    [fxFlexOrder]="getFlexOrder(item.layoutContent)"
                    fxLayout="column"
                    fxLayoutAlign="center center"
                >
                    <h1
                        class="banner-heading"
                        [ngClass.lt-md]="{ 'mob-banner-heading': true }"
                        style="color:{{ item?.layoutContent?.title?.color }}"
                    >
                        {{ item?.layoutContent?.title?.text }}
                    </h1>
                    <button
                        *ngIf="item?.layoutContent?.button"
                        mat-flat-button
                        class="mob-button"
                        ngClass.gt-xs="desk-button"
                        style="background: {{
                            item?.layoutContent?.button?.background
                        }};color:{{
                            item?.layoutContent?.button?.title?.color
                        }}"
                    >
                        {{ item?.layoutContent?.button?.title?.text }}
                    </button>
                </div>
                <div #spacer fxFlex="0 1 60%" fxFlexOrder="0"></div>
            </div>
        </div>
        <div
            *ngIf="item.layoutType === 'product-offer-col-banner'"
            class="product-col-banner product-col-banner-mobile"
            ngClass.gt-xs="product-col-banner-desktop"
            [ngStyle.xs]="{
                margin: '0px 26px 40px 26px',
                paddingBottom: '50px'
            }"
            [ngStyle.gt-xs]="{ margin: '0px 34px 38px 34px' }"
        >
            <picture
                *ngIf="item?.layoutContent?.banner?.video === null"
                class="product-col-banner-image"
                [ngClass]="{ 'image-banner-shimmer': showShimmer }"
            >
                <img
                    class="image-holder"
                    src="{{ item?.layoutContent?.banner?.image }}"
                    (click)="processLink(item?.layoutContent?.banner?.link)"
                    appImageCDN
                />
            </picture>
        </div>
        <div
            fxShow
            fxShow.xs="false"
            *ngIf="item?.layoutType === '2-col-banner-with-video'"
            fxLayout.xs="column"
            fxLayoutAlign.gt-xs="space-between"
            [ngStyle.xs]="{ margin: '0px 26px 26px 26px' }"
            [ngStyle.gt-xs]="{ marginBottom: '50px' }"
        >
            <div
                *ngIf="item?.layoutContent?.banner"
                ngClass.gt-xs="two-col-banner-video-desktop"
                fxLayout.gt-xs="row"
                [ngStyle.gt-xs]="{ justifyContent: 'center' }"
                [ngStyle.xs]="{ marginBottom: '35px' }"
                fxFlex.gt-xs="0 0 50%"
                [fxFlex.gt-xs]="getFlex(item.layoutContent)"
                [fxFlexOrder.gt-xs]="getFlexOrder(item.layoutContent)"
            >
                <div [ngStyle.gt-xs]="{ width: '90%' }">
                    <picture
                        *ngIf="
                            !item?.layoutContent?.banner?.video &&
                            !item?.layoutContent?.banner?.youTubeKey
                        "
                        style="width: 100%"
                    >
                        <img
                            [ngStyle.gt-xs]="{ width: '100%' }"
                            class="image-holder"
                            src="{{ item?.layoutContent?.banner?.image }}"
                            appImageCDN
                        />
                    </picture>
                    <video
                        *ngIf="item?.layoutContent?.banner?.video"
                        poster="{{
                            item?.layoutContent?.banner?.image + posterImageCDN
                        }}"
                        [ngStyle.xs]="{ objectFit: 'cover' }"
                        [ngStyle.gt-xs]="{ height: '40vw' }"
                        style="
                            border: none;
                            position: relative;
                            top: 0;
                            width: 100%;
                            object-fit: cover;
                        "
                        loop
                        muted
                        autoplay
                        oncanplay="this.play()"
                        onloadedmetadata="this.muted = true"
                        playsinline
                        webkit-playsinline
                    >
                        <source
                            src="{{
                                item?.layoutContent?.banner?.video + webm
                            }}"
                            type="video/webm"
                        />
                        <source
                            [src]="
                                convertWebToMp4(
                                    item?.layoutContent?.banner?.video
                                )
                            "
                            type="video/mp4"
                        />
                    </video>
                    <picture *ngIf="item?.layoutContent?.banner?.youTubeKey">
                        <iframe
                            id="video"
                            frameBorder="0"
                            *ngIf="item?.layoutContent?.banner?.youTubeKey"
                            fxFlex="0 0 100%"
                            [ngStyle.gt-xs]="{ height: '40vw' }"
                            class="video swiper-lazy"
                            allow="autoplay; fullscreen"
                            [src]="
                                'https://www.youtube.com/embed/' +
                                    item?.layoutContent?.banner?.youTubeKey +
                                    '?rel=0&autoplay=1&autopause=0&mute=1&playlist=' +
                                    item?.layoutContent?.banner?.youTubeKey +
                                    '&loop=1&controls=0&enablejsapi=1' +
                                    '&modestbranding=1&showinfo=0&iv_load_policy=3&fs=0&cc_load_policy=0'
                                    | pipesafe
                            "
                        ></iframe>
                    </picture>
                </div>
            </div>

            <div
                class="two-col-banner-video-container"
                fxLayout="column"
                fxFlex.gt-xs="0 0 50%"
                ngClass.gt-xs="two-col-content-desktop"
                [ngStyle.xs]="{
                    marginLeft: '17px',
                    paddingRight: '35px'
                }"
                fxLayoutAlign="center"
            >
                <h1
                    *ngIf="item?.layoutContent?.title?.text"
                    class="two-col-banner-video-title"
                    [ngStyle.gt-xs]="{ margin: '0' }"
                    [ngStyle.xs]="{
                        fontSize: '25px'
                    }"
                    style="color:{{ item?.layoutContent?.title?.color }}"
                    >{{ item?.layoutContent?.title?.text }}<br />
                </h1>
                <p
                    class="two-col-banner-video-subtitle"
                    [ngStyle.xs]="{
                        fontSize: '18px',
                        margin: '0',
                        textAlign: 'start',
                        lineHeight: '20px'
                    }"
                    style="color:{{
                        item?.layoutContent?.subtitle?.color
                    }};white-space: pre-line"
                    >{{ item?.layoutContent?.subtitle?.text }}
                </p>
                <button
                    *ngIf="item?.layoutContent?.button"
                    (click)="processLink(item?.layoutContent?.button?.link)"
                    class="two-col-banner-video-button"
                    fxLayout="coloumn"
                    [ngStyle.xs]="{
                        fontSize: '18px',
                        width: '188px',
                        marginTop: '24px'
                    }"
                    mat-flat-button
                    style="color:{{
                        item?.layoutContent?.button?.title?.color
                    }}"
                    >{{ item?.layoutContent?.button?.title?.text }}
                    <img
                        style="width: 20px; height: 40px; margin: 0 0 0 6px"
                        src="{{ item?.layoutContent?.button?.icon }}"
                        appImageCDN
                    />
                </button>
                <div
                    *ngIf="item?.layoutContent?.featureHighlights"
                    fxLayout="coloumn"
                    style="position: relative; text-align: center"
                    [ngStyle.xs]="{ marginTop: '43px', width: '100%' }"
                    [ngStyle.gt-xs]="{ marginTop: '41px' }"
                    fxLayoutAlign="start"
                >
                    <div
                        *ngFor="
                            let highlight of item?.layoutContent
                                ?.featureHighlights
                        "
                        fxLayout="column"
                        [ngStyle.xs]="{ width: '33%' }"
                        [ngStyle.gt-xs]="{ width: '100%', marginRight: '91px' }"
                        style="align-items: center"
                    >
                        <div>
                            <img
                                appImageCDN
                                class="two-col-icon"
                                [ngStyle.xs]="{ width: '85px' }"
                                src="{{ highlight.icon }}"
                            />
                        </div>
                        <div style="width: 70%; text-align: center">
                            <p class="two-col-specText">{{
                                highlight?.text
                            }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div
            fxShow
            fxShow.gt-xs="false"
            *ngIf="item?.layoutType === '2-col-banner-with-video'"
            fxLayout.xs="column"
            fxLayoutAlign.gt-xs="space-between"
            [ngStyle.xs]="{ margin: '0px 26px 0px 26px' }"
            [ngStyle.gt-xs]="{ marginBottom: '50px' }"
        >
            <div
                class="two-col-banner-video-container"
                fxLayout="column"
                fxFlex.gt-xs="0 0 50%"
                ngClass.gt-xs="two-col-content-desktop"
                style="margin-bottom: 38px"
                fxLayoutAlign="center"
            >
                <h1
                    *ngIf="item?.layoutContent?.title?.text"
                    class="two-col-banner-video-title"
                    [ngStyle.gt-xs]="{ margin: '0' }"
                    [ngStyle.xs]="{
                        fontSize: '25px'
                    }"
                    style="color:{{ item?.layoutContent?.title?.color }}"
                    >{{ item?.layoutContent?.title?.text }}<br />
                </h1>
                <p
                    class="two-col-banner-video-subtitle"
                    [ngStyle.xs]="{
                        fontSize: '13px',
                        margin: '0',
                        textAlign: 'start',
                        lineHeight: '17px'
                    }"
                    style="color:{{
                        item?.layoutContent?.subtitle?.color
                    }};white-space: pre-line"
                    >{{ item?.layoutContent?.subtitle?.text }}
                </p>
            </div>

            <div
                *ngIf="item?.layoutContent?.banner"
                ngClass.gt-xs="two-col-banner-video-desktop"
                fxLayout.gt-xs="row"
                [ngStyle.gt-xs]="{ justifyContent: 'center' }"
                [ngStyle.xs]="{ marginBottom: '38px' }"
                fxFlex.gt-xs="0 0 50%"
                [fxFlex.gt-xs]="getFlex(item.layoutContent)"
                [fxFlexOrder.gt-xs]="getFlexOrder(item.layoutContent)"
            >
                <div [ngStyle.gt-xs]="{ width: '90%' }">
                    <picture
                        *ngIf="
                            !item?.layoutContent?.banner?.video &&
                            !item?.layoutContent?.banner?.youTubeKey
                        "
                        style="width: 100%"
                    >
                        <img
                            [ngStyle.gt-xs]="{ width: '100%' }"
                            class="image-holder"
                            src="{{ item?.layoutContent?.banner?.image }}"
                            appImageCDN
                        />
                    </picture>
                    <video
                        *ngIf="item?.layoutContent?.banner?.video"
                        poster="{{
                            item?.layoutContent?.banner?.image + posterImageCDN
                        }}"
                        [ngStyle.xs]="{ objectFit: 'cover' }"
                        [ngStyle.gt-xs]="{ height: '40vw' }"
                        style="
                            border: none;
                            position: relative;
                            top: 0;
                            width: 100%;
                            object-fit: cover;
                        "
                        loop
                        muted
                        autoplay
                        oncanplay="this.play()"
                        onloadedmetadata="this.muted = true"
                        playsinline
                        webkit-playsinline
                    >
                        <source
                            src="{{
                                item?.layoutContent?.banner?.video + webm
                            }}"
                            type="video/webm"
                        />
                        <source
                            [src]="
                                convertWebToMp4(
                                    item?.layoutContent?.banner?.video
                                )
                            "
                            type="video/mp4"
                        />
                    </video>
                    <picture *ngIf="item?.layoutContent?.banner?.youTubeKey">
                        <iframe
                            id="video"
                            frameBorder="0"
                            *ngIf="item?.layoutContent?.banner?.youTubeKey"
                            fxFlex="0 0 100%"
                            class="video swiper-lazy"
                            allow="autoplay; fullscreen"
                            [src]="
                                'https://www.youtube.com/embed/' +
                                    item?.layoutContent?.banner?.youTubeKey +
                                    '?rel=0&autoplay=1&autopause=0&mute=1&playlist=' +
                                    item?.layoutContent?.banner?.youTubeKey +
                                    '&loop=1&controls=0&enablejsapi=1' +
                                    '&modestbranding=1&showinfo=0&iv_load_policy=3&fs=0&cc_load_policy=0'
                                    | pipesafe
                            "
                        ></iframe>
                    </picture>
                </div>
            </div>
        </div>

        <div *ngIf="item?.layoutType === 'title-description'">
            <div
                class="description__header"
                ngClass.xs="description__header__mobile"
            >
                <h1
                    class="description__header__title"
                    [ngStyle.xs]="{ fontSize: '18px', marginBottom: '6px' }"
                    >{{ item?.layoutContent?.title?.text }}</h1
                >
                <ng-container
                    *ngFor="let desc of item?.layoutContent?.description"
                >
                    <p
                        class="description__header__subtitle"
                        style="white-space: pre-line; line-height: 22px"
                        [ngStyle.xs]="{ fontSize: '13px', lineHeight: '17px' }"
                        >{{ desc }}</p
                    >
                </ng-container>
            </div>
        </div>

        <div
            *ngIf="item?.layoutType === 'cta'"
            [ngStyle.gt-xs]="{ textAlign: 'center', marginBottom: '38px' }"
            [ngStyle.xs]="{ margin: '0px 26px 26px 26px' }"
        >
            <button
                ngClass.xs="call-to-action-button-mobile"
                class="call-to-action-button-desktop"
                mat-raised-button
                (click)="processLink(item?.layoutContent?.button?.link)"
                color="primary"
                >{{ item?.layoutContent?.button?.title?.text }}</button
            >
        </div>

        <div *ngIf="item?.layoutType === 'trending-category'" fxLayout="column">
            <h1 class="desktop-ccp-header" ngStyle.xs="font-size:24px">{{
                item?.layoutContent?.categoryData?.text
            }}</h1>
            <hr
                *ngIf="
                    item?.layoutContent?.categoryData?.feed[activeTab].items
                        .length > 1
                "
            />
            <mat-tab-group
                *ngIf="item?.layoutContent?.categoryData?.length > 1"
                class="desktop-tab"
            >
                <mat-tab
                    *ngFor="let item of item?.layoutContent?.categoryData?.feed"
                >
                    <ng-template mat-tab-label>
                        <a class="tab-header" (click)="processLink(item?.link)">
                            {{ item?.text }}
                        </a>
                    </ng-template>
                </mat-tab>
            </mat-tab-group>
            <div
                *ngIf="
                    item?.layoutContent?.categoryData?.feed[activeTab].items
                        .length > 1
                "
                fxLayout="row wrap"
                class="ccp-items"
                ngStyle.xs="padding-bottom:38px;"
            >
                <a
                    [routerLink]="[item?.link | pageIdFromLink]"
                    [queryParams]="item?.link | queryParamFromLink"
                    class="ccp-anchor"
                    *ngFor="
                        let item of (item?.layoutContent?.categoryData?.feed)[
                            activeTab
                        ].items;
                        let i = index
                    "
                    (click)="processLink(item?.link)"
                    fxFlex.xs="0 0 49%"
                >
                    <div
                        fxLayout="column"
                        style="width: 100%"
                        fxLayoutAlign="space-between center"
                    >
                        <img
                            src="{{ item?.image }}"
                            appImageCDN
                            alt=""
                            class="circle-style-image"
                        />
                        <p class="list-title">
                            {{ item?.title?.text }}
                            <span
                                style="
                                    color: #c21122;
                                    font-size: 12px;
                                    text-decoration: none;
                                    vertical-align: super;
                                    font-family: 'Roboto Regular', sans-serif;
                                "
                                *ngIf="item?.newLaunch"
                                >New</span
                            >
                        </p>
                    </div>
                </a>
            </div>
        </div>
    </ng-container>
</div>

<app-error-page *ngIf="errorCaught" [error]="errors"></app-error-page>
